import React from 'react'
import Radio from '@mui/material/Radio'
import * as S from './styles.js'

export function YesOrNoRadioInput({ id, value, label, options = [], handleChange, error }) {
	const yesId = `${id}-yes`;
	const noId = `${id}-no`;

	return (<>
		<S.Text>{label}</S.Text>
		<S.ControlContainer>
			<S.Control>
				<Radio
					name={id}
					id={yesId}
					checked={value === 'Sim'}
					onChange={handleChange}
					value={"Sim"}
					inputProps={{ 'aria-label': "Sim"}}
					color="primary"
					/>
				<S.Label htmlFor={yesId}>
					Sim
				</S.Label>
			</S.Control>
			<S.Control>
				<Radio
					name={id}
					id={noId}
					checked={value === 'Não'}
					onChange={handleChange}
					value={"Não"}
					inputProps={{ 'aria-label': "Não"}}
					color="primary"
					/>
				<S.Label htmlFor={noId}>
					Não
				</S.Label>
			</S.Control>
			{error && <div className="MuiFormHelperText-root MuiFormHelperText-contained Mui-error">{error}</div>}
		</S.ControlContainer>
	</>)
}
